/* eslint-disable unicorn/prefer-module -- consumed by both webpack (ESM interop) and gatsby-ssr.js */
const LOCALES = {
    EN: 'en',
    DE: 'de',
};

const DEFAULT_LOCALE = LOCALES.EN;

// og:locale values, keyed by our locale codes
const OG_LOCALES = {
    [LOCALES.EN]: 'en_US',
    [LOCALES.DE]: 'de_DE',
};

// hreflang values, keyed by our locale codes
const HREFLANGS = {
    [LOCALES.EN]: 'en',
    [LOCALES.DE]: 'de',
};

/**
 * Resolve the locale from a pathname.
 * Localized pages live under a language prefix (e.g. /de/services/...);
 * everything else is the default locale.
 */
const getLocaleFromPath = (pathname = '') => {
    const localized = Object.values(LOCALES).find(
        (locale) =>
            locale !== DEFAULT_LOCALE &&
            (pathname === `/${locale}` || pathname.startsWith(`/${locale}/`)),
    );

    return localized || DEFAULT_LOCALE;
};

module.exports = {
    LOCALES,
    DEFAULT_LOCALE,
    OG_LOCALES,
    HREFLANGS,
    getLocaleFromPath,
};
